import { createAction, GLOBALS } from '@wix/communities-blog-client-common';
import { appendAuthHeaders } from '../../common/controller/helpers';
import { getCustomRceColors } from '../../common/selectors/rce-settings';
import { type PostPageThunkAction } from '../types';

export const ADD_TEXT_COLOR_REQUEST = 'rceSettings/ADD_TEXT_COLOR_REQUEST';
export const ADD_TEXT_COLOR_SUCCESS = 'rceSettings/ADD_TEXT_COLOR_SUCCESS';
const ADD_TEXT_COLOR_FAILURE = 'rceSettings/ADD_TEXT_COLOR_FAILURE';
export const addTextColorRequest = createAction(ADD_TEXT_COLOR_REQUEST);
export const addTextColorSuccess = createAction(ADD_TEXT_COLOR_SUCCESS);
const addTextColorFailure = createAction(ADD_TEXT_COLOR_FAILURE);

export const addTextColor =
  (color: string): PostPageThunkAction<void> =>
  async (dispatch, _, { httpClient, errorHandler, platformApi }) => {
    dispatch(addTextColorRequest({ color }));

    const { withErrorHandler, showError } = errorHandler;

    try {
      const { data: rceSettings } = await withErrorHandler(
        () =>
          httpClient.post(
            `${GLOBALS.API_BASE_URL_CLIENT}/_api/rce-settings`,
            { color },
            {
              headers: appendAuthHeaders(platformApi),
            },
          ),
        { errorCodesMap: {} },
      );
      dispatch(addTextColorSuccess({ rceSettings }));
    } catch (error) {
      showError(error);
      dispatch(addTextColorFailure());
    }
  };

export const SET_USER_COLORS_REQUEST = 'rceSettings/SET_USER_COLORS_REQUEST';
export const SET_USER_COLORS_SUCCESS = 'rceSettings/SET_USER_COLORS_SUCCESS';
export const SET_USER_COLORS_FAILURE = 'rceSettings/SET_USER_COLORS_FAILURE';
export const setUserColorsRequest = createAction(SET_USER_COLORS_REQUEST);
export const setUserColorsSuccess = createAction(SET_USER_COLORS_SUCCESS);
export const setUserColorsFailure = createAction(SET_USER_COLORS_FAILURE);

const normalizeColors = (colors: string[]) =>
  Array.from(new Set(colors.map((color) => color.toLowerCase())));

export const setUserColors =
  (colors: string[]): PostPageThunkAction<void> =>
  async (dispatch, getState, { httpClient, errorHandler, platformApi }) => {
    const previousColors = getCustomRceColors(getState()) ?? [];
    const nextColors = normalizeColors(colors);

    dispatch(setUserColorsRequest({ colors: nextColors }));

    const { withErrorHandler, showError } = errorHandler;

    try {
      const { data: rceSettings } = await withErrorHandler(
        () =>
          httpClient.put(
            `${GLOBALS.API_BASE_URL_CLIENT}/_api/rce-settings`,
            { colors: nextColors },
            {
              headers: appendAuthHeaders(platformApi),
            },
          ),
        { errorCodesMap: {} },
      );
      dispatch(setUserColorsSuccess({ rceSettings }));
    } catch (error) {
      showError(error);
      dispatch(setUserColorsFailure({ colors: previousColors }));
    }
  };

const FETCH_RCE_SETTINGS_REQUEST = 'rceSettings/FETCH_REQUEST';
export const FETCH_RCE_SETTINGS_SUCCESS = 'rceSettings/FETCH_SUCCESS';
const FETCH_RCE_SETTINGS_FAILURE = 'rceSettings/FETCH_FAILURE';
const fetchRceSettingsRequest = createAction(FETCH_RCE_SETTINGS_REQUEST);
export const fetchRceSettingsSuccess = createAction(FETCH_RCE_SETTINGS_SUCCESS);
export const fetchRceSettingsFailure = createAction(FETCH_RCE_SETTINGS_FAILURE);

export const fetchRceSettings =
  (): PostPageThunkAction<void> =>
  async (dispatch, _, { httpClient, errorHandler, platformApi }) => {
    dispatch(fetchRceSettingsRequest());

    const { withErrorHandler, showError } = errorHandler;

    try {
      const { data: rceSettings } = await withErrorHandler(
        () =>
          httpClient.get(`${GLOBALS.API_BASE_URL_CLIENT}/_api/rce-settings`, {
            headers: appendAuthHeaders(platformApi),
          }),
        { errorCodesMap: {} },
      );
      dispatch(fetchRceSettingsSuccess({ rceSettings }));
    } catch (error) {
      showError(error);
      dispatch(fetchRceSettingsFailure());
    }
  };
